import React from 'react';
import { Icon, Spin, Modal, Tooltip } from 'antd';
import { useDeleteDomain } from 'mutation/domain-warmup';

export default function DeleteDomainButton({ domain }) {
  const { mutate, isLoading } = useDeleteDomain();
  const onClick = () => {
    Modal.confirm({
      title: 'Do you want to delete this domain?',
      onOk: () => {
        mutate(domain.name);
      },
    });
  };
  return (
    <Spin spinning={isLoading}>
      <Tooltip title="Delete Domain">
        <Icon
          style={{ fontSize: 22 }}
          theme="twoTone"
          twoToneColor="#C70000"
          type="delete"
          onClick={onClick}
        />
      </Tooltip>
    </Spin>
  );
}
